import { AuthenticatedUserContext } from 'providers/AuthenticatedUserProvider';
import { useContext } from 'react';

export const useAuthenticatedUser = () => {
  const context = useContext(AuthenticatedUserContext);
  if (!context) {
    throw new Error(
      'useAuthenticatedUser must be used within an AuthenticatedUserProvider'
    );
  }
  return context;
};
